// Campus photo for /colleges/gonzaga-university: CC BY-SA 3.0, by SCUMATT, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASt_Aloysius_at_GU.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/gonzaga-university/; credited under the photo.
const photo = {
    "slug": "gonzaga-university",
    "alt": "The twin spires of St. Aloysius Church on the Gonzaga University campus in Spokane, Washington, on a spring day",
    "src": "/colleges/gonzaga-university/campus-1600.webp",
    "srcSmall": "/colleges/gonzaga-university/campus-800.webp",
    "srcMid": "/colleges/gonzaga-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/gonzaga-university/og.jpg",
    "title": "St Aloysius at GU",
    "author": "SCUMATT",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASt_Aloysius_at_GU.jpg",
    "read": "2026-10-01"
};

export default photo;
